import { useContext, useMemo, useState } from "react";

import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Overlay from "../Componentes/Overlay";
import SideMenu from "../Componentes/SideMenu";
import SideMenuBtn from "../Componentes/SideMenuBtn";
import TestesAlcoolDrogasContent from "../Modulos/AtendimentoAmb/TestesAlcoolDrogas/Content";
import ModalNovoTeste from "../Modulos/AtendimentoAmb/TestesAlcoolDrogas/ModalNovoTeste";
import { AuthContext } from "../Auth/AuthProvider";
import { VerifyPermission } from "../Funcoes/VerifyPermission";
import { useModal } from "../contexts/ModalContext";

const PERMISSAO_BASE = { modulo: "ssma", submodulo: "atendimento-amb" };

const AtendimentoAmbTestesAlcoolDrogas = () => {
    const { openModal, closeModal, isModalOpen } = useModal();
    const { user } = useContext(AuthContext);
    const [listRefreshKey, setListRefreshKey] = useState(0);

    const podeLancarEditar = useMemo(
        () => VerifyPermission(user, { ...PERMISSAO_BASE, funcao: "testes-alcool-drogas-lancar-editar" }),
        [user]
    );

    const openSidebar = () => openModal("testesAlcoolDrogasSidebar");

    const openNovoTeste = () => {
        if (!podeLancarEditar) return;
        closeModal();
        openModal("testeNovo");
    };

    return (
        <>
            <NavBar
                title="ATENDIMENTO AMBULATORIAL — TESTES ÁLCOOL E DROGAS"
                goBackOnePage
                setSideBar={openSidebar}
            />
            <GenericBody>
                <TestesAlcoolDrogasContent refreshKey={listRefreshKey} />
            </GenericBody>

            {isModalOpen("testesAlcoolDrogasSidebar") && (
                <Overlay state changeContent={closeModal}>
                    <SideMenu>
                        {podeLancarEditar && (
                            <SideMenuBtn
                                button="NOVO TESTE"
                                clickFunc={openNovoTeste}
                            />
                        )}
                    </SideMenu>
                </Overlay>
            )}

            {podeLancarEditar && isModalOpen("testeNovo") && (
                <ModalNovoTeste
                    fechar={closeModal}
                    onSaved={() => setListRefreshKey((k) => k + 1)}
                />
            )}
        </>
    );
};

export default AtendimentoAmbTestesAlcoolDrogas;
